var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIAdd = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -72.189)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 72.189)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.425 -47.166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-9.561,134.381h-6.527a2.368,2.368,0,0,1-2.364-2.365V125.49a2.367,2.367,0,0,1,2.364-2.364h3.264a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-3.264a1.366,1.366,0,0,0-1.364,1.364v6.526a1.367,1.367,0,0,0,1.364,1.365h6.527A1.367,1.367,0,0,0-8.2,132.016v-3.262a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.262A2.368,2.368,0,0,1-9.561,134.381Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.7,126.923a.5.5,0,0,1-.5-.5v-5.595a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v5.595A.5.5,0,0,1-7.7,126.923Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.9,124.126h-5.594a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H-4.9a.5.5,0,0,1,.5.5A.5.5,0,0,1-4.9,124.126Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIAdd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/i_add.e4c8e615.svg";
export { ForwardRef as ReactComponent };